import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "label-front-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.25 10.5004C5.25 10.0862 5.58579 9.75037 6 9.75037L18 9.75037C18.4142 9.75037 18.75 10.0862 18.75 10.5004C18.75 10.9146 18.4142 11.2504 18 11.2504L6 11.2504C5.58579 11.2504 5.25 10.9146 5.25 10.5004Z" }, null, -1),
    _createElementVNode("path", { d: "M7.25 13.5001C7.25 13.0859 7.58579 12.7501 8 12.7501L16 12.7501C16.4142 12.7501 16.75 13.0859 16.75 13.5001C16.75 13.9143 16.4142 14.2501 16 14.2501L8 14.2501C7.58579 14.2501 7.25 13.9143 7.25 13.5001Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.75 7.00012C21.75 4.37677 19.6234 2.25012 17 2.25012L7 2.25012C4.37665 2.25012 2.25 4.37677 2.25 7.00012L2.25 17.0001C2.25 19.6235 4.37665 21.7501 7 21.7501L17 21.7501C19.6234 21.7501 21.75 19.6235 21.75 17.0001L21.75 7.00012ZM17 3.75012C18.7949 3.75012 20.25 5.2052 20.25 7.00012L20.25 17.0001C20.25 18.795 18.7949 20.2501 17 20.2501L7 20.2501C5.20507 20.2501 3.75 18.795 3.75 17.0001L3.75 7.00012C3.75 5.2052 5.20507 3.75012 7 3.75012L17 3.75012Z"
    }, null, -1)
  ])))
}
export default { render: render }